var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalloutsDirectionSetterLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.335 12.085H9.50769L11.4227 14L9.50768 15.915H6.335V12.085Z",
    stroke: "black",
    strokeWidth: 1.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 14H23.75",
    stroke: "black",
    strokeWidth: 1.17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalloutsDirectionSetterLeft);
export default __webpack_public_path__ + "static/media/callouts-direction-setter-left.08237f101ea6783be85763f21f1e5490.svg";
export { ForwardRef as ReactComponent };